import { FinalizeProcessStepRecordingRequestSchema, FinalizeProcessStepRecordingResponseSchema } from './finalize-process-step-recording.schema';
/**
 * Finalize Process Step Recording Endpoint Contract
 * Transitions pending_finalization → finalized, persists the user-approved
 * name/description, creates the feedback survey, and assigns successors.
 */ export const finalizeProcessStepRecordingContract = {
    method: 'POST',
    path: '/api/v2/process-step-recording/:id/finalize',
    description: 'Finalize a process step recording with the user-approved name and description',
    requestSchema: FinalizeProcessStepRecordingRequestSchema,
    responseSchema: FinalizeProcessStepRecordingResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Name or description missing',
            401: 'Unauthorized',
            404: 'Step recording not found'
        }
    }
};

//# sourceMappingURL=finalize-process-step-recording.contract.js.map